import { render } from "./EventSlider.vue?vue&type=template&id=9477b194&scoped=true"
import script from "./EventSlider.vue?vue&type=script&lang=js"
export * from "./EventSlider.vue?vue&type=script&lang=js"

import "./EventSlider.vue?vue&type=style&index=0&id=9477b194&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9477b194"]])

export default __exports__